var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"spinner-overlay"},[_c('div',{staticClass:"spinner-gif"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }